import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Select,
  Form,
  Skeleton,
} from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { formatString } from "../../../utils/formatString";
import HeadingChip from "../../atoms/HeadingChip";
import TicketChip from "../../atoms/TicketChip";

const { Title } = Typography;

const Tickets = (props) => {
  const [tickets, setTickets] = useState([]);
  const [loader, setLoader] = useState(true);

  const {
    ticketlist,
    category,
    viewTicket,
    count,
    clickDropDown,
    onCount,
    handleStatusChange,
    showStatusOption,
    showClosedTickets,
    setShowClosedTickets,
    setVisible,
    setTrigger,
    setParentTicketId,
  } = props;

  useEffect(() => {
    if (ticketlist != null) {
      setTickets(ticketlist);
      setLoader(false);
    } else {
      setTickets([]);
      setLoader(true);
    }
  }, [ticketlist]);

  //TODO: after status api is given change it

  const getStatus = (status, ticketSubStatus) => {
    if (showStatusOption?.length > 0) {
      if (status?.toLowerCase() === "draft") {
        return ticketSubStatus
          ? status + "-" + formatString(ticketSubStatus)
          : formatString(status);
      }
      const stat = showStatusOption.find((val) => val.value === status);
      return stat?.label ?? formatString(status);
    }
  };

  if (category === "Closed" && !showClosedTickets) {
    return (
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <HeadingChip heading={category} value={count} />
        </Col>
        <Col span={24}>
          <Card
            className="ticket-parent-card"
            bordered={false}
            style={{ borderRadius: 4, textAlign: "center" }}
          >
            <PlusCircleOutlined
              style={{ fontSize: 30, marginTop: 47, marginBottom: 47 }}
              onClick={() => setShowClosedTickets()}
            />
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <HeadingChip heading={category} value={count} />
      </Col>
      <Col span={24}>
        <Card
          className="ticket-parent-card"
          bordered={false}
          style={{ borderRadius: 4 }}
        >
          {showStatusOption && showStatusOption.length && (
            <Select
              bordered={true}
              onChange={handleStatusChange}
              size="large"
              options={showStatusOption}
              style={{ width: "100%" }}
              defaultValue="All"
            />
          )}
          {tickets.length > 0 ? (
            <Space size={24} direction="vertical" className="w-100">
              <div
                className="ag-nospace-body ag-noborder-head"
                style={{
                  height: 550,
                  overflowY: "auto",
                  padding: "0 !important",
                }}
              >
                <Space size={24} direction="vertical" className="w-100">
                  {tickets.map((item: any, index) => (
                    <TicketChip
                      key={index}
                      ticketID={item.srNumber}
                      isPaidService={item?.isPaidService}
                      title={item.title}
                      type={item?.category?.name}
                      subtype={item.secondary_category}
                      setParentTicketId={setParentTicketId}
                      data={item}
                      status={getStatus(
                        item.ticketStatus,
                        item?.ticketSubStatus
                      )}
                      setVisible={setVisible}
                      setTrigger={setTrigger}
                      tenant={item.tenant}
                      itemStatus={item.ticketStatus}
                      unit={item.unit}
                      ticketsCategory={category}
                      clickDropDown={(e) => clickDropDown(item, e)}
                      appartment={item.propertyName}
                      statusDisplayName={
                        showStatusOption?.find(
                          (element) =>
                            element.value == item.case_status_type_name
                        )?.label
                      }
                      location={item.location}
                      recuring={item.ticket_parent_id}
                      clickView={viewTicket}
                    />
                  ))}
                </Space>
              </div>
              {tickets.length < count ? (
                <Button type="link" block onClick={onCount}>
                  View More
                </Button>
              ) : (
                <Button></Button>
              )}
            </Space>
          ) : (
            <Fragment>
              <Skeleton loading={loader} active paragraph />
              {!loader && (
                <Title
                  level={5}
                  className="highlight ag-primary mb-0 p-1 text-center"
                >
                  There are currently no {category === "New" && "new"}
                  {category === "Closed" && "closed"} tickets{" "}
                  {category === "In Progress" && "in progress"}
                  {category === "Scheduled" && "Scheduled"}
                </Title>
              )}
            </Fragment>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default Tickets;
